<template>
  <div class="default">
    <Head />
    <slot></slot>
    <Foot />
    <CPopForm />
    <PopWarning />
  </div>
</template>

<script>
import Head from '@/components/layout/Head'
import Foot from '@/components/layout/Foot'
import CPopForm from '@/components/home/CPopForm'
import PopWarning from '@/components/common/PopWarning.vue'

export default {
  name: 'Default',
  components: { PopWarning, CPopForm, Foot, Head }
}
</script>

<style scoped lang="scss">
@import '~@/assets/style/variable.scss';

.default {
  width: 100%;
  min-width: 1200px;
  position: relative;
  //padding-top: $headHeight;
}
</style>
